import React, {useEffect, useRef, useState }   from 'react';
import Button         from '@material-ui/core/Button';
import TextField      from '@material-ui/core/TextField';
import Grid           from '@material-ui/core/Grid'
import MenuItem       from '@material-ui/core/MenuItem';
import InputAdornment from '@material-ui/core/InputAdornment';
import IconButton     from '@material-ui/core/IconButton';
import Modal          from '@material-ui/core/Modal';
import Fade           from '@material-ui/core/Fade';
import Typography     from '@material-ui/core/Typography';
import queryString    from 'query-string'
import Resizer        from 'react-image-file-resizer';
import 'bootstrap/dist/css/bootstrap.min.css';
import firebase       from 'firebase/compat/app';
import 'firebase/compat/auth';
import DeleteOutline  from '@material-ui/icons/DeleteOutline';

//画像リサイズ用定数
const resizer = {
  maxWidth:           1920,    //変換後画像の最大横幅
  maxHeight:          1920,    //変換後画像の最大縦幅
  maxThumbnailWidth:  320,     //変換後サムネイル画像の最大横幅
  maxThumbnailHeight: 320,     //変換後サムネイル画像の最大縦幅
  compressFormat:     "JPEG",  //圧縮フォーマット（JPEG, PNG or WEBP）
  quality:            80,      //画質（0 ~ 100 圧縮しない場合は100をセットする。）
  outputType:         "bolb" //出力タイプ（base64, bolb, file）
}

/**
 * ModalFollowUp
 * 経過情報登録・更新・削除モーダル。
 * @param {object} props プロパティ
 * @param {string} props.DisplayName 表示対象者の名前
 * @param {string} props.MedicalRecordId 症状カードID
 * @param {function} [props.handleModalClose] 親画面のモーダルを閉じるコールバック
 * @param {function} [props.handleReloadModalClose] 親画面で再読込を伴うクローズ用コールバック
 */
export default function ModalFollowUp(props) {
  // URL情報から更新・削除対象のDocIdを取得
  let docId = '';
  if(window.location.search){
    docId = queryString.parse(window.location.search).data||null;
  }
  //if(this.props.location.search){
  //  docId = queryString.parse(this.props.location.search).data||null;
  //}

  const getDateTimeLocalFormat = (date = new Date()) => {
    const target = (Object.prototype.toString.call(date) === '[object Date]' && !Number.isNaN(date.getTime())) ? date : new Date()
    return `${target.getFullYear()}-${(target.getMonth()+1).toString().padStart(2, '0')}-${target.getDate().toString().padStart(2, '0')}T${target.getHours().toString().padStart(2, '0')}:${target.getMinutes().toString().padStart(2, '0')}`
  }

  const normalizeFollowUpTime = (value) => {
    if (!value) return ''

    if (Object.prototype.toString.call(value) === '[object Date]' && !Number.isNaN(value.getTime())) {
      return getDateTimeLocalFormat(value)
    }

    if (typeof value !== 'string') return ''
    if (/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}$/.test(value)) return value

    const dateWithYear = value.match(/^(\d{4})年(\d{2})月(\d{2})日（.）(\d{2})時(\d{2})分$/)
    if (dateWithYear) {
      const [, year, month, day, hour, minute] = dateWithYear
      return `${year}-${month}-${day}T${hour}:${minute}`
    }

    const dateWithoutYear = value.match(/^(\d{2})月(\d{2})日（.）(\d{2})時(\d{2})分$/)
    if (dateWithoutYear) {
      const now = new Date()
      const [, month, day, hour, minute] = dateWithoutYear
      return `${now.getFullYear()}-${month}-${day}T${hour}:${minute}`
    }

    const parsed = new Date(value.replace(/-/g, '/'))
    if (!Number.isNaN(parsed.getTime())) {
      return getDateTimeLocalFormat(parsed)
    }

    return ''
  }
  

  //DisplayName:     this.props.location.state.DisplayName,     // 表示対象者の名前
  //MedicalRecordId: this.props.location.state.MedicalRecordId, // 症状カードID
  const [ DisplayName                                         ] = useState(props.DisplayName)      // 表示対象者の名前
  const [ MedicalRecordId                                     ] = useState(props.MedicalRecordId)  // 症状カードID
  const [ FollowUpId                                          ] = useState(docId)                  //経過情報ID(更新・削除用)
  const [ FollowUpTime,            setFollowUpTime            ] = useState(getDateTimeLocalFormat()) //入力日時(自動入力)
  const [ Appetite,                setAppetite                ] = useState('')    //食欲
  const [ BodyTemperature,         setBodyTemperature         ] = useState('')    //体温
  const [ Moisture,                setMoisture                ] = useState('')    //水分摂取
  const [ Mood,                    setMood                    ] = useState('')    //機嫌
  const [ RunnyNose,               setRunnyNose               ] = useState('')    //鼻水
  const [ Headache,                setHeadache                ] = useState('')    //頭痛
  const [ Diarrhea,                setDiarrhea                ] = useState('')    //下痢
  const [ Vomit,                   setVomit                   ] = useState('')    //嘔吐
  const [ Phlegm,                  setPhlegm                  ] = useState('')    //痰
  const [ BreathSounds,            setBreathSounds            ] = useState('')    //呼吸音
  const [ Stomachache,             setStomachache             ] = useState('')    //腹痛
  const [ Eruption,                setEruption                ] = useState('')    //発疹
  const [ Spasm,                   setSpasm                   ] = useState('')    //けいれん
  const [ Note,                    setNote                    ] = useState('')    //メモ
  const [ image_url,               setimage_url               ] = useState('')    //経過記録画像URL
  const [ CreateTime,              setCreateTime              ] = useState('')    //作成日時
  const [ UpdateTime,              setUpdateTime              ] = useState('')    //更新日時
  const [ ,                        setFollowUp_image_url      ] = useState('')    //経過登録用画像（値未使用）
  const [ data_image_list,         setdata_image_list         ] = useState([])    //経過画像格納用リスト
  const [ FollowUp_image_change,   setFollowUp_image_change   ] = useState(false) //経過画像登録状況
  const [ DeleteConfirmOpen,       setDeleteConfirmOpen       ] = useState(false) //画像削除確認モーダル表示
  const [ DeleteTargetImage,       setDeleteTargetImage       ] = useState(null)  //削除対象の画像
  const [ DeleteTargetIndex,       setDeleteTargetIndex       ] = useState(-1)    //削除対象の画像インデックス

  const dataImageListRef = useRef({
    list: [
      //{
      //  number:       "(数値)",     //画像番号
      //  source_url:   "(文字列)",   //取り込み元画像
      //  image_url:    "(文字列)",   //経過画像パス
      //  thum_url:     "(文字列)",   //経過サムネイル画像パス
      //  CreateTime:   "(日時)",     //作成時刻
      //  UpdateTime:   "(日時)",     //更新時刻
      //  ShootingTime: "(日時)",     //撮影時刻
      //  image_change: "(ブール値)", //経過登録画像の変更有無（true=変更あり、false=変更なし）
      //}
    ],
    uploadList: [
      //{
      //  image_url:    "(文字列)",   //経過画像パス
      //  thum_url:     "(文字列)",   //経過サムネイル画像パス
      //  CreateTime:   "(日時)",     //作成時刻
      //  UpdateTime:   "(日時)",     //更新時刻
      //  ShootingTime: "(日時)",     //撮影時刻
      //}
    ]
  })

  const resetDataImageList = () => {
    dataImageListRef.current.list = []
    dataImageListRef.current.uploadList = []
  }
  useEffect(() => {
    resetDataImageList()
    setdata_image_list([])
    setFollowUp_image_change(false)
    return () => resetDataImageList()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [FollowUpId])
  //console.log(`this.state.DisplayName: ${this.state.DisplayName}`)
  //console.log(`this.state.MedicalRecordId: ${this.state.MedicalRecordId}`)
  //console.log(`docId: ${docId}`)

  /**
   * 画面上に表示される各要素の選択肢一覧
   * (下記の設定を変更すれば、render()部の修正は不要)
   */
  const choicesMap = {
    RunnyNose: [    // 鼻水
      "なし",
      "やや出ている",
      "出ている"],
    Headache: [     // 頭痛
      "なし",
      "やや出ている",
      "出ている"],
    Diarrhea: [     // 下痢
      "なし",
      "やや出ている",
      "出ている"],
    Vomit: [        // 嘔吐
      "なし",
      "やや出ている",
      "出ている"], 
    Phlegm: [       // 痰
      "なし",
      "やや出ている",
      "出ている"],
    BreathSounds: [ // 呼吸音
      "異常なし",
      "やや異常あり",
      "異常あり"],
    Stomachache: [  // 腹痛
      "なし",
      "やや痛い",
      "痛い"],
    Eruption: [ // 発疹
      "なし",
      "やや出ている",
      "あり"],
    Spasm: [        // けいれん
      "なし",
      "やや出ている",
      "あり"],
    Test: [        // テスト
      "なし",
      "やや出ている",
      "あり"],
    x: ["-"]
  }

  /**
   * 登録・削除の場合、登録済みデータをfirestoreから取得
   * (コンポーネントマウント時に実行)
   */
  // async componentDidMount() {
  //   await this.ReadFollowUp()    //データベースから経過情報を読み出す。
  // }

  /**
   * 現在日付を[YYYYMMDDhhmmss]形式で返す関数
   */
  const getDateIdFormat = () => {
    var now = new Date();
    return "" + now.getFullYear()
      + (now.getMonth()+1).toString().padStart(2, '0')
      + now.getDate().toString().padStart(2, '0')
      + now.getHours().toString().padStart(2, '0')
      + now.getMinutes().toString().padStart(2, '0')
      + now.getSeconds().toString().padStart(2, '0');
  }


  /**
   * 削除ボタン押下時の処理
   */
  const handleDeleteButtonClick = async() => {
    // 削除実行の確認用ポップアップ
    if (!window.confirm("経過情報を削除します")) {
      alert("削除をキャンセルしました");
      // this.props.history.goBack();
      return;
    }

    await deleteFollowUp();
  }

  const deleteFollowUp = async() => {
    let db = firebase.firestore()

    //削除処理は前画面からデータを引き継いでいる場合のみ実行可能
    if(FollowUpId){
      await db.collection("MedicalRecords").doc(MedicalRecordId)
      .collection("datas").doc(FollowUpId).delete()
      .then(()=>{
        alert("削除に成功しました")
      })
      .catch(function(error) {
        alert("削除に失敗しました")
        console.log("経過情報の削除に失敗しました ", error);
      });
    }
    //this.props.history.goBack();
    handleReloadModalClose() //モーダル画面を閉じ、画面データの再読み込みを行う。
  }

  /**
   * 登録ボタン押下時の処理
   */
  const handleRegistButtonClick = async() => {
    await registFollowUp();
  }

  /**
   * Firestoreから既存の経過情報(対象Doc)を読み出し、表示用ステートへ反映する。
   */
  const ReadFollowUp = async() => {
    console.log("ReadFollowUp() start!!")
    var db = firebase.firestore()

    // firestoreから現在の登録データを取得し、モーダル表示画面に反映
    if(FollowUpId){
      let FollowUpTime = '' //入力日時
      let Appetite = ''     //食欲
      let Moisture = ''     //水分について
      let Mood = ''         //機嫌について
      await db.collection("MedicalRecords").doc(MedicalRecordId)
      .collection("datas").doc(FollowUpId)
      .get().then(async(doc)=>{
        if(doc.data()){
          var data = doc.data()
          var FollowUp_source_url = ''                                          //経過登録用
          var FollowUp_thum_url   = ("thum_url"  in data) ? data.thum_url  : '' //経過登録用サムネイル画像
          var FollowUp_image_url  = ("image_url" in data) ? data.image_url : '' //経過登録用画像
          dataImageListRef.current.list = []
          dataImageListRef.current.uploadList = []
          
          //入力日時のフォーマット変更
          if (Object.prototype.toString.call(data.FollowUpTime) === '[object String]') {
            FollowUpTime = normalizeFollowUpTime(data.FollowUpTime)
          } else if (data.FollowUpTime && typeof data.FollowUpTime.toDate === 'function') {
            FollowUpTime = normalizeFollowUpTime(data.FollowUpTime.toDate())
          }
          
          //食欲について
          Appetite = data.Appetite || ''
          switch(Appetite) {
            case '◯':
            case 'ok':
            case '普段通り':
              Appetite = '◯'
              break
            case '△':
            case '普段の半分くらい':
              Appetite = '△'
              break
            case '✕':
            case 'no':
            case '全く食べられない':
              Appetite = '✕'
              break
            case '':
            default:
              Appetite = ''
              break
          }
          
          //水分について
          Moisture = data.Moisture || ''
          switch(Moisture) {
            case '◯':
            case 'ok':
            case '普段通り':
              Moisture = '◯'
              break
            case '△':
            case '普段の半分くらい':
              Moisture = '△'
              break
            case '✕':
            case 'no':
            case '全く取れない':
              Moisture = '✕'
              break
            case '':
            default:
              Moisture = ''
              break
          }
          
          //機嫌について
          Mood = data.Mood || ''
          switch(Mood) {
            case '◯':
            case 'ok':
            case '良い':
              Mood = '◯'
              break
            case '△':
            case 'やや悪い':
              Mood = '△'
              break
            case '✕':
            case 'no':
            case '悪い':
              Mood = '✕'
              break
            case '':
            default:
              Mood = ''
              break
          }
          
          //旧型式の経過画像データに画像登録がある場合は、経過画像リストに読み込む（2021/08/29 追加 高橋）
          if (FollowUp_image_url !== '' && FollowUp_thum_url !== '') {
            //ブラウザ上で一時格納する、画像リストに旧形式で参照データを格納した画像を0番目の画像として格納する
            dataImageListRef.current.list.push({
              number:       0,                                                                //画像番号
              source_url:   FollowUp_source_url,                                              //取り込み元画像（旧型式の経過データは空欄として扱う。）
              image_url:    FollowUp_image_url,                                               //経過画像パス
              thum_url:     FollowUp_thum_url,                                                //経過サムネイル画像パス
              CreateTime:   ("CreateTime"   in data) ? data.CreateTime.toDate() : new Date(), //経過情報が初めて記録された時刻
              UpdateTime:   ("UpdateTime"   in data) ? data.UpdateTime.toDate() : new Date(), //経過情報更新時刻
              ShootingTime: ("CreateTime"   in data) ? data.CreateTime.toDate() : new Date(), //経過情報画像作成時刻
              image_change: false,                                                            //経過登録画像の変更有無（true=変更あり、false=変更なし）
            })
            
            //データベースにアップロードする画像リストに画像を登録する
            dataImageListRef.current.uploadList.push({
              image_url:    FollowUp_image_url,                                               //経過画像パス
              thum_url:     FollowUp_thum_url,                                                //経過サムネイル画像パス
              CreateTime:   ("CreateTime"   in data) ? data.CreateTime.toDate() : new Date(), //経過情報が初めて記録された時刻
              UpdateTime:   ("UpdateTime"   in data) ? data.UpdateTime.toDate() : new Date(), //経過情報更新時刻
              ShootingTime: ("CreateTime"   in data) ? data.CreateTime.toDate() : new Date(), //経過情報画像作成時刻
            })
          }
          
          if("images" in data){
            //新形式で保存された画像情報読み込みを行う
            data.images.forEach((image, index)=>{
              
              //旧形式で保存された画像情報を、新形式用画像情報読み込みしないようにする
              if(index !== '0' && FollowUp_image_url !== image.image_url && FollowUp_thum_url !== image.thum_url){
                dataImageListRef.current.list.push({
                  number:       index,                                                                //画像番号
                  source_url:   '',                                                                   //取り込み元画像（旧型式の経過データは空欄として扱う。）
                  image_url:    image.image_url,                                                      //経過画像パス
                  thum_url:     image.thum_url,                                                       //経過サムネイル画像パス
                  CreateTime:   ("CreateTime"   in image) ? image.CreateTime.toDate()   : new Date(), //経過情報が初めて記録された時刻
                  UpdateTime:   ("UpdateTime"   in image) ? image.UpdateTime.toDate()   : new Date(), //経過情報更新時刻
                  ShootingTime: ("ShootingTime" in image) ? image.ShootingTime.toDate() : new Date(), //経過情報画像撮影時刻
                  image_change: false,                                                                //経過登録画像の変更有無（true=変更あり、false=変更なし）
                })
                
                dataImageListRef.current.uploadList.push({
                  image_url:    image.image_url,                                                      //経過画像パス
                  thum_url:     image.thum_url,                                                       //経過サムネイル画像パス
                  CreateTime:   ("CreateTime"   in image) ? image.CreateTime.toDate()   : new Date(), //経過情報が初めて記録された時刻
                  UpdateTime:   ("UpdateTime"   in image) ? image.UpdateTime.toDate()   : new Date(), //経過情報更新時刻
                  ShootingTime: ("ShootingTime" in image) ? image.ShootingTime.toDate() : new Date(), //経過情報画像撮影時刻
                })
              }
            })
          }
          
          // this.setState({
          setFollowUpTime    (FollowUpTime                            || '') //入力日時
          setAppetite        (Appetite                                || '') //食欲
          setBodyTemperature (Number(data.BodyTemperature).toFixed(1) || '') //体温
          setMoisture        (Moisture                                || '') //水分摂取
          setMood            (Mood                                    || '') //機嫌
          setRunnyNose       (data.RunnyNose                          || '') //鼻水
          setHeadache        (data.Headache                           || '') //頭痛
          setDiarrhea        (data.Diarrhea                           || '') //下痢
          setVomit           (data.Vomit                              || '') //嘔吐
          setPhlegm          (data.Phlegm                             || '') //痰
          setBreathSounds    (data.BreathSounds                       || '') //呼吸音
          setStomachache     (data.Stomachache                        || '') //腹痛
          setEruption        (data.Eruption                           || '') //発疹
          setSpasm           (data.Spasm                              || '') //けいれん
          setNote            (data.Note                               || '') //メモ
          setimage_url       (data.image_url                          || '') //経過情報画像URL
          setCreateTime      (data.CreateTime.toDate()                || '') //作成日時
          setUpdateTime      (data.UpdateTime.toDate()                || '') //更新日時
          setdata_image_list (dataImageListRef.current.list)                            //propsに経過画像リストを反映する。
          // })
        }
      })
    }
  }

  //モーダルを非表示状態に切り替える
  const handleModalClose = () => {
    if(typeof props.handleModalClose == 'function'){
      props.handleModalClose() // 症状カード画面のモーダルを閉じる
    }
  }

  //モーダルを非表示状態に切り替え、症状カード画面で再読み込みする
  const handleReloadModalClose = async() => {
    if(typeof props.handleReloadModalClose == 'function'){
      await props.handleReloadModalClose() // 症状カード画面のモーダルを閉じ、画面内データを再読み込みする。
    }
  }

  /**
   * 経過情報登録モーダルの各選択肢の変更を制御する関数
   * (TextFieldのname要素とstateの名前を対応付けて処理を共通化)
   * @param {*} e 各選択肢のTextField要素
   */
  const handleChange = (e) => {
    const { name, value } = e.target
    const setters = {
      FollowUpTime:    setFollowUpTime,
      Appetite:        setAppetite,
      BodyTemperature: setBodyTemperature,
      Moisture:        setMoisture,
      Mood:            setMood,
      RunnyNose:       setRunnyNose,
      Headache:        setHeadache,
      Diarrhea:        setDiarrhea,
      Vomit:           setVomit,
      Phlegm:          setPhlegm,
      BreathSounds:    setBreathSounds,
      Stomachache:     setStomachache,
      Eruption:        setEruption,
      Spasm:           setSpasm,
      Note:            setNote,
    }
    const setter = setters[name]
    if (setter) setter(value)
  }

  const handleClearFollowUpTime = () => {
    setFollowUpTime('')
  }

  // 画像削除確認モーダルを開く
  const handleOpenDeleteConfirm = (image, index) => {
    setDeleteTargetImage(image)
    setDeleteTargetIndex(index)
    setDeleteConfirmOpen(true)
  }

  // 画像削除確認モーダルを閉じる
  const handleCloseDeleteConfirm = () => {
    setDeleteConfirmOpen(false)
    setDeleteTargetImage(null)
    setDeleteTargetIndex(-1)
  }

  // 画像リストを再番号付けして同期する
  const reindexImageLists = (list) => {
    const reindexed = list.map((img, idx) => ({
      ...img,
      number: idx,
    }))

    const uploadList = reindexed.map((img) => ({
      image_url: img.image_url,
      thum_url: img.thum_url,
      CreateTime: img.CreateTime,
      UpdateTime: img.UpdateTime,
      ShootingTime: img.ShootingTime,
    }))

    dataImageListRef.current.list = reindexed
    dataImageListRef.current.uploadList = uploadList
    setdata_image_list(reindexed.slice(0, reindexed.length))
  }

  // Storageの画像を削除する（URLの場合のみ）
  const deleteStorageByUrl = async (url) => {
    if (!url || typeof url !== 'string') return
    if (url.startsWith('data:')) return
    try {
      await firebase.storage().refFromURL(url).delete()
    } catch (e) {
      console.log('deleteStorageByUrl error:', e)
    }
  }

  // 画像削除を実行する
  const handleDeleteImageConfirm = async () => {
    if (!DeleteTargetImage || DeleteTargetIndex < 0) {
      handleCloseDeleteConfirm()
      return
    }

    const target = DeleteTargetImage
    const targetIndex = DeleteTargetIndex
    const nextList = dataImageListRef.current.list.filter((_, idx) => idx !== targetIndex)
    reindexImageLists(nextList)
    setFollowUp_image_change(true)
    handleCloseDeleteConfirm()

    // 新規登録時はローカルの削除のみ
    if (!FollowUpId) return

    await Promise.all([
      deleteStorageByUrl(target.image_url),
      deleteStorageByUrl(target.thum_url),
    ])

    try {
      const docRef = firebase.firestore()
        .collection("MedicalRecords")
        .doc(MedicalRecordId)
        .collection("datas")
        .doc(FollowUpId)
      const snap = await docRef.get()
      if (!snap.exists) return

      const data = snap.data() || {}
      const images = Array.isArray(data.images) ? data.images : []
      const filtered = images.filter((img) => {
        const imgUrl = img?.image_url || ''
        const thumUrl = img?.thum_url || ''
        return !(imgUrl === target.image_url && thumUrl === target.thum_url)
      })

      await docRef.update({ images: filtered })
    } catch (e) {
      console.log('delete image firestore error:', e)
    }
  }

  //画像添付時の処理
  //handleRegistFamilyImage = (e) =>{
  //  var btn_input_file = document.getElementById('file_affectedPartImage');
  //  btn_input_file.click();
  //}

  // 経過画像変更用「参照」ボタンを押した際の処理
  const handleFollowUpReferenceButton = () => {
    var btn_input_file = document.getElementById("file_affectedPartImage");
    btn_input_file.click();
  }

  //経過記録画像変更時の処理
  const handleFollowUpImageFileChange = async(e) => {
    var createObjectURL = (window.URL || window.webkitURL).createObjectURL || window.createObjectURL;
    var files = e.target.files
    var fileCount = files.length //読み込んだファイル数
    var num = dataImageListRef.current.list.length
    for (var i = 0; i < fileCount; i++ ) {
      var source_url     = createObjectURL(files[i])
      var image_url      = await resizeImage(files[i])
      var image_thum_url = await resizeThumbnailImage(files[i])
    
      dataImageListRef.current.list.push({
        number:       (num + i),                       //画像番号
        source_url:   source_url,                      //取り込み元画像
        image_url:    image_url,                       //経過画像パス
        thum_url:     image_thum_url,                  //経過サムネイル画像パス
        CreateTime:   new Date(),                      //経過情報が初めて記録された時刻
        UpdateTime:   new Date(),                      //経過情報更新時刻
        ShootingTime: new Date(files[i].lastModified), //経過画像撮影日時
        image_change: true,                            //経過登録画像の変更有無（true=変更あり、false=変更なし）
      })

      dataImageListRef.current.uploadList.push({
        image_url:    image_url,                       //経過画像パス
        thum_url:     image_thum_url,                  //経過サムネイル画像パス
        CreateTime:   new Date(),                      //経過情報が初めて記録された時刻
        UpdateTime:   new Date(),                      //経過情報更新時刻
        ShootingTime: new Date(files[i].lastModified), //経過画像撮影日時
      })
    }

    // this.setState({
    //FollowUp_image_url:      image_url, // 経過画像をブラウザメモリ上で参照するオブジェクトURLで取得する。
    setFollowUp_image_url('')   // 経過画像をブラウザメモリ上で参照するオブジェクトURLで取得する。javascriptのセキュリティエラー対策で参照URLを登録しない
    setFollowUp_image_change(true) // 経過登録画像の変更有りとして記録する。
    setdata_image_list(dataImageListRef.current.list) //propsに経過画像リストを反映する。
    // }) 
  }

  //画像リサイズ処理（サムネイル画像）
  const resizeThumbnailImage = (file) => new Promise((resolve) => {
    Resizer.imageFileResizer(
      file,                       //画像ファイルのパス
      resizer.maxThumbnailWidth,  //変換後サムネイル画像の最大横幅
      resizer.maxThumbnailHeight, //変換後サムネイル画像の最大縦幅
      resizer.compressFormat,     //圧縮フォーマット（JPEG, PNG or WEBP）
      resizer.quality,            //画質（0 ~ 100 圧縮しない場合は100をセットする。）
      0,                          //画像の回転度数（0,90,180,270,360）
      (uri) => {resolve(uri)},    //responseUriFunc
      resizer.outputType,         //出力タイプ（base64, bolb, file）
    )
  })

  //画像リサイズ処理
  const resizeImage = (file) => new Promise((resolve) => {
    Resizer.imageFileResizer(
      file,                       //画像ファイルのパス
      resizer.maxWidth,           //変換後サムネイル画像の最大横幅
      resizer.maxHeight,          //変換後サムネイル画像の最大縦幅
      resizer.compressFormat,     //圧縮フォーマット（JPEG, PNG or WEBP）
      resizer.quality,            //画質（0 ~ 100 圧縮しない場合は100をセットする。）
      0,                          //画像の回転度数（0,90,180,270,360）
      (uri) => {resolve(uri)},    //responseUriFunc
      resizer.outputType,         //出力タイプ（base64, bolb, file）
    )
  })

  //経過画像登録処理
  const RegistFollowUpImage = async(doc_id) => {
    console.log('RegistFollowUpImage() doc_id:' + doc_id)
    if(FollowUp_image_change === true){
      //dataImageListRef.current.list.forEach((images)=>{
      await Promise.all(dataImageListRef.current.list.map(async(images)=>{
      //for (const images of dataImageListRef.current.list) {
        var ShootingTime = `${images.ShootingTime.getFullYear()}/${('0' + (images.ShootingTime.getMonth() + 1)).slice(-2)}/${('0' + images.ShootingTime.getDate()).slice(-2)} ` +
                          ` ${('0' + images.ShootingTime.getHours()).slice(-2)}:${('0' + images.ShootingTime.getMinutes()).slice(-2)}:${('0' + images.ShootingTime.getSeconds()).slice(-2)}`
        //サムネイル画像アップロード
        if(images.thum_url.includes('data:image/jpeg;base64,') && images.image_url.includes('data:image/jpeg;base64,')){ //base64形式フォーマットとなっていることを確認する
          var thum_data        = images.thum_url
          var data             = images.image_url
          var thum_fileName    = images.number + "-thum.jpg"                                                        // サムネイル画像のファイル名を設定
          var fileName         = images.number + ".jpg"                                                             // 画像のファイル名を設定
          var storageRef       = firebase.storage().ref('member_data_image')                                        // Storageの参照先ディレクトリを「member_data_image」に設定する。
          var thum_ImagesRef   = storageRef.child(MedicalRecordId + '/' + doc_id + '/' + thum_fileName) // サムネイル画像のStorageの参照先ファイル名を設定する。
          var ImagesRef        = storageRef.child(MedicalRecordId + '/' + doc_id + '/' + fileName)      // 画像のStorageの参照先ファイル名を設定する。
          var update_thum_url  = ''                                                                                 // サムネイル画像のStorageアクセス用URLを格納する
          var update_image_url = ''                                                                                 // 画像のStorageアクセス用URLを格納する
          
          // サムネイル画像をfirebase Storageに保存する。
          // Data stringからアップロードする。
          await thum_ImagesRef.putString(thum_data, 'data_url', {
            contentType: 'image/jpeg',
            customMetadata: {
              ShootingTime: ShootingTime
            }
          }).catch(function(er){
            console.log("image upload error", er)
          })
          
          // 画像をfirebase Storageに保存する。
          // Data stringからアップロードする。
          await ImagesRef.putString(data, 'data_url', {
            contentType: 'image/jpeg',
            customMetadata: {
              ShootingTime: ShootingTime
            }
          }).catch(function(er){
            console.log("image upload error", er)
          })
          
          // firebase Storageへ保存したサムネイル画像への参照URLを取得
          await thum_ImagesRef.getDownloadURL().then((url)=>{
            update_thum_url = url
            dataImageListRef.current.list[images.number].thum_url       = update_thum_url
            dataImageListRef.current.uploadList[images.number].thum_url = update_thum_url
          })
          
          // firebase Storageへ保存した画像への参照URLを取得
          await ImagesRef.getDownloadURL().then((url)=>{
            update_image_url = url
            dataImageListRef.current.list[images.number].image_url       = update_image_url
            dataImageListRef.current.uploadList[images.number].image_url = update_image_url
          })
        }
      }))
    }
    console.log('RegistFollowUpImage() doc_id:' + doc_id + ' finish !')
  }

  //経過情報登録
    /**
     * 経過情報を新規作成または更新してFirestoreへ保存する。
     */
    const registFollowUp = async() => {
    let db = firebase.firestore()
    let doc_id = getDateIdFormat()

    const setData = {  // NULLチェックは右記のショートハンドで実施([条件式]?[true]:[false] → ||)
      Appetite:        Appetite         || '', //食欲
      BodyTemperature: BodyTemperature  || '', //体温（数値型）
      BreathSounds:    BreathSounds     || '', //呼吸音
      CreateTime:      CreateTime       || firebase.firestore.FieldValue.serverTimestamp(), //作製時刻（firebaseのサーバー時刻）
      Diarrhea:        Diarrhea         || '', //下痢
      Eruption:        Eruption         || '', //発疹
      FollowUpTime:    FollowUpTime     || '', //入力日時
      Headache:        Headache         || '', //頭痛
      //images:          dataImageListRef.current.uploadList,           //登録画像リスト
      image_url:       image_url        || '', //経過記録画像URL
      Moisture:        Moisture         || '', //水分
      Mood:            Mood             || '', //機嫌
      Note:            Note             || '', //メモ
      Phlegm:          Phlegm           || '', //痰
      RunnyNose:       RunnyNose        || '', //鼻水
      Spasm:           Spasm            || '', //けいれん
      Stomachache:     Stomachache      || '', //腹痛
      UpdateTime:      UpdateTime       || firebase.firestore.FieldValue.serverTimestamp(), //更新時刻（firebaseのサーバー時刻）
      Vomit:           Vomit            || '', //嘔吐
    }
    console.log("FollowUpRegist registFollowUp["+MedicalRecordId+"]")

    if(FollowUpId){ //更新時
      await RegistFollowUpImage(doc_id)
      setData.images = dataImageListRef.current.uploadList //登録画像リスト
      await db.collection("MedicalRecords").doc(MedicalRecordId)
      .collection("datas").doc(FollowUpId).set(setData).then(async()=>{
        doc_id = FollowUpId
        alert("経過情報を登録しました")
        await handleReloadModalClose() //モーダル画面を閉じ、画面データの再読み込みを行う。
      })
      .catch(function(error) {
        alert("更新に失敗しました")
        console.log("経過情報の更新に失敗しました ", error);
      });
    }
    else{ //新規登録時
      await RegistFollowUpImage(doc_id)
      setData.images = dataImageListRef.current.uploadList //登録画像リスト
      await db.collection("MedicalRecords").doc(MedicalRecordId)
      .collection("datas").doc(doc_id).set(setData).then(async()=>{
        alert("経過情報を登録しました")
        await handleReloadModalClose() //モーダル画面を閉じ、画面データの再読み込みを行う。
      })
      .catch(function(error) {
        alert("登録に失敗しました")
        console.log("経過情報の登録に失敗しました ", error);
      });
    }
  }

  useEffect(() => { //ページ表示時、情報更新時に実行
    // componentDidMount のタイミングで実行したい処理を記述
    console.log("useEffect: ReadFollowUp")
    ReadFollowUp()
    // 次の行のコメントでeslintの余分なワーニングを抑制する。
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [setdata_image_list])

  useEffect(() => { //ページを離れる際に実行
    // componentDidMount のタイミングで実行したい処理を記述
    return () => {
      // componentWillUnmount のタイミングで実行したい処理を記述
      document.title = 'ふぁみかるくん' //家族ホーム画面を離れる際、ページタイトルを初期値に戻す
    }
  }, [])
  
 
  return (
    <React.Fragment>
      <Grid container direction="row" justifyContent="flex-start" alignItems="flex-end" spacing={2}>
        <Grid item xs={12}>
          経過：自宅での様子を残しておきましょう
        </Grid>
        <Grid container item xs={12} justifyContent="flex-end">
          {DisplayName}
        </Grid>
        <Grid item xs={12}>
          <TextField
            fullWidth
            required
            id="FollowUpTime"
            label="日時"
            name="FollowUpTime"
            type="datetime-local"
            value={FollowUpTime}
            onChange={(e)=>handleChange(e)}
            InputLabelProps={{shrink: true}}
            InputProps={{
              inputProps: {step: 300},
              endAdornment: FollowUpTime ? (
                <InputAdornment position="end">
                  <Button size="small" onClick={handleClearFollowUpTime}>クリア</Button>
                </InputAdornment>
              ) : null,
            }}
          />
        </Grid>
      
        <Grid item xs={5}>
          <TextField select fullWidth required id="selBodyTemperature" label="体温" name="BodyTemperature" value={BodyTemperature} onChange={(e)=>handleChange(e)}>
            {(()=>{
              //体温の選択肢アイテムを用意
              const tmp1List = [];
              for ( let temp = Number(35.5).toFixed(1); temp <= 42.0; temp = Number(Number(temp) + 0.1).toFixed(1) ){
                tmp1List.push(<MenuItem key={temp} value={temp}>{temp}</MenuItem>)
              }
              return tmp1List
            })()}
          </TextField>
        </Grid>
        <Grid item xs={1}>℃</Grid>
        <Grid item xs={6}>
          <TextField select fullWidth id="selRunnyNose" label="鼻水" name="RunnyNose" value={RunnyNose} onChange={(e)=>handleChange(e)}>
            {choicesMap.RunnyNose.map(item => <MenuItem key={item} value={item}>{item}</MenuItem>)}
          </TextField>
        </Grid>
        <Grid item xs={6}>
          <TextField select fullWidth id="selHeadache" label="頭痛" name="Headache" value={Headache} onChange={(e)=>handleChange(e)}>
            {choicesMap.Headache.map(item => <MenuItem key={item} value={item}>{item}</MenuItem>)}
          </TextField>
        </Grid>
        <Grid item xs={6}>
          <TextField select fullWidth id="selPhlegm" label="痰" name="Phlegm" value={Phlegm} onChange={(e)=>handleChange(e)}>
            {choicesMap.Phlegm.map(item => <MenuItem key={item} value={item}>{item}</MenuItem>)}
          </TextField>
        </Grid>
        <Grid item xs={6}>
          <TextField select fullWidth id="selBreathSounds" label="呼吸音" name="BreathSounds" value={BreathSounds} onChange={(e)=>handleChange(e)}>
            {choicesMap.BreathSounds.map(item => <MenuItem key={item} value={item}>{item}</MenuItem>)}
          </TextField>
        </Grid>
        <Grid item xs={6}>
          <TextField select fullWidth id="selVomit" label="嘔吐" name="Vomit" value={Vomit} onChange={(e)=>handleChange(e)}>
            {choicesMap.Vomit.map(item => <MenuItem key={item} value={item}>{item}</MenuItem>)}
          </TextField>
        </Grid>
        <Grid item xs={6}>
          <TextField select fullWidth id="selDiarrhea" label="下痢" name="Diarrhea" value={Diarrhea} onChange={(e)=>handleChange(e)}>
            {choicesMap.Diarrhea.map(item => <MenuItem key={item} value={item}>{item}</MenuItem>)}
          </TextField>
        </Grid>
        <Grid item xs={6}>
          <TextField select fullWidth id="selStomachache" label="腹痛" name="Stomachache" value={Stomachache} onChange={(e)=>handleChange(e)}>
            {choicesMap.Stomachache.map(item => <MenuItem key={item} value={item}>{item}</MenuItem>)}
          </TextField>
        </Grid>
        <Grid item xs={6}>
          <TextField select fullWidth id="selEruption" label="発疹" name="Eruption" value={Eruption} onChange={(e)=>handleChange(e)}>
            {choicesMap.Eruption.map(item => <MenuItem key={item} value={item}>{item}</MenuItem>)}
          </TextField>
        </Grid>
        <Grid item xs={6}>
          <TextField select fullWidth id="selSpasm" label="けいれん" name="Spasm" value={Spasm} onChange={(e)=>handleChange(e)}>
            {choicesMap.Spasm.map(item => <MenuItem key={item} value={item}>{item}</MenuItem>)}
          </TextField>
        </Grid>
        <Grid item xs={4}>
          <TextField select fullWidth id="selAppetite" label="食欲" name="Appetite" value={Appetite} onChange={(e)=>handleChange(e)}>
            <MenuItem value="">　</MenuItem>
            <MenuItem value="◯">◯(普段通り食べれている)</MenuItem>
            <MenuItem value="△">△(普段の半分くらい食べれている)</MenuItem>
            <MenuItem value="✕">✕(全く食べれていない)</MenuItem>
          </TextField>
        </Grid>
        <Grid item xs={4}>
          <TextField select fullWidth id="selMoisture" label="水分摂取" name="Moisture" value={Moisture} onChange={(e)=>handleChange(e)}>
            <MenuItem value="">　</MenuItem>
            <MenuItem value="◯">◯(普段通り取れている)</MenuItem>
            <MenuItem value="△">△(普段の半分くらい取れている)</MenuItem>
            <MenuItem value="✕">✕(全く取れていない)</MenuItem>
          </TextField>
        </Grid>
        <Grid item xs={4}>
          <TextField select fullWidth id="selMood" label="機嫌" name="Mood" value={Mood} onChange={(e)=>handleChange(e)}>
            <MenuItem value="">　</MenuItem>
            <MenuItem value="◯">◯(機嫌が良い)</MenuItem>
            <MenuItem value="△">△(機嫌がやや悪い)</MenuItem>
            <MenuItem value="✕">✕(機嫌が悪い)</MenuItem>
          </TextField>
        </Grid>
        <Grid item xs={6}></Grid>

        <Grid item xs={12}>
          <TextField fullWidth multiline minRows={5} id="inputNote" label="メモ" name="Note" value={Note} onChange={(e)=>handleChange(e)}/>
        </Grid>

        {/* 経過画像登録 */}
        <Grid item xs={12}>症状がわかる画像があれば登録しましょう</Grid>
        <div id="FollowUpImg">
          {data_image_list.map((images, index)=>(
            <Grid item xs={12} key={'DataImage_' + images.number}>
              <div style={{position: 'relative', margin: '5px 0'}}>
                <img style={{width: '100%'}} src={images.image_url} alt={images.CreateTime.toLocaleDateString()} />
                <IconButton
                  size="small"
                  onClick={()=>handleOpenDeleteConfirm(images, index)}
                  style={{
                    position: 'absolute',
                    top: '-10px',
                    right: '-10px',
                    backgroundColor: '#ffffff',
                    boxShadow: '0 0 2px rgba(0,0,0,0.4)'
                  }}
                  aria-label="画像を削除"
                >
                  <DeleteOutline fontSize="small" />
                </IconButton>
              </div>
            </Grid>
          ))}
        </div>
        <Grid item xs={12} style={{display: 'block'}}>
          {/* 読み込みした経過画像を表示する。 */}
        </Grid>
        <Grid item xs={12}>
          <Button variant="outlined" color="primary" onClick={()=>handleFollowUpReferenceButton()}>
          画像を選ぶ
          </Button>
          <input type="file" multiple id="file_affectedPartImage" accept=".jpg,.jpeg,.png,.webp,.svg" style={{display: 'none'}} onChange={(e)=>handleFollowUpImageFileChange(e)} />
        </Grid>
        <Grid item xs={12}>　</Grid>
        {/*
        <Grid item xs={12}>
          <div>
            <Button fullWidth variant="outlined" color="primary" onClick={()=>handleRegistFamilyImage()} >
              画像を添付する
              <canvas id="cv_image" width="0" height="0" style={{position:'absolute', textAlign:'center'}} src={image_url} />
            </Button>
          </div>
          <div>
            <input type="file" id="file_affectedPartImage" accept=".jpg,.jpeg,.png" style={{display:'none'}} onChange={this.handleImageFileChange} />
          </div>
        </Grid>
        */}
      </Grid>
      <Grid container justifyContent="space-between" alignItems="flex-start" style={{marginTop: '1rem',}}>
        <div style={{display: (FollowUpId ? 'block' : 'none')}}> {/* 経過情報が登録済みの場合のみ削除ボタンを表示する */}
          <Button variant="outlined" color="secondary" onClick={()=>handleDeleteButtonClick()}>削除</Button>
        </div>
        <Button variant="outlined" color="primary" onClick={()=>handleModalClose()}>キャンセル</Button>
        <Button variant="outlined" color="primary" onClick={()=>handleRegistButtonClick()}>保存</Button>
      </Grid>
      <Modal
        open={DeleteConfirmOpen}
        onClose={handleCloseDeleteConfirm}
        closeAfterTransition
      >
        <Fade in={DeleteConfirmOpen}>
          <div
            style={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              backgroundColor: '#fff',
              padding: '24px',
              borderRadius: '8px',
              minWidth: '320px',
              boxShadow: '0 8px 24px rgba(0,0,0,0.2)'
            }}
          >
            <Typography variant="h6" gutterBottom>
              こちらの画像を削除しますか？
            </Typography>
            <Typography variant="body2" gutterBottom>
              ※削除した画像は復元できません。ご了承ください。
            </Typography>
            {DeleteTargetImage?.image_url ? (
              <div style={{marginTop: '12px', marginBottom: '8px', textAlign: 'center'}}>
                <img
                  src={DeleteTargetImage.image_url}
                  alt="削除対象の画像"
                  style={{maxWidth: '100%', maxHeight: '240px', borderRadius: '6px'}}
                />
              </div>
            ) : null}
            <div style={{display: 'flex', justifyContent: 'space-between', gap: '12px', marginTop: '16px'}}>
              <Button variant="outlined" color="primary" onClick={()=>handleCloseDeleteConfirm()}>
                キャンセル
              </Button>
              <Button variant="contained" color="secondary" onClick={()=>handleDeleteImageConfirm()}>
                削除
              </Button>
            </div>
          </div>
        </Fade>
      </Modal>
    </React.Fragment>
  )
}
